import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.userCityStore.selectedCity)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($setup.userCityStore.selectedCity.title), 1))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}